// 法语
const fr = {
    // 首页-激活说明
    activateExplain: {
        title: 'Activez votre extension de garantie et obtenez le cadeau spécial pour vous',
        desp: `Condition appliquée: pour se qualifier, les clients acceptent de partager leur expérience d'achat avec les produits achetés que nous utilisons activement depuis au moins une semaine.`,
        conditions: [
            'Uniquement pour les clients qui ont acheté les produits sur Amazon.',
            `Chaque client ne peut réclamer qu'un seul CADEAU GRATUIT pour un produit. (Ce qui signifie que peu importe le nombre de fois où vous achetez le même produit, vous ne pouvez obtenir qu'un seul cadeau GRATUIT).`,
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: 'Activez votre extension de garantie et obtenez le cadeau GRATUIT MAINTENANT!',
        desp: 'Disponible uniquement pour les clients existants',
        name: 'Nom',
        namePlaceholder: `Entrez le nom du destinataire`,
        nameErrMsg: `Le nom est incorrect.`,
        email: 'Courriel',
        emailPlaceholder: `Entrez votre courriel`,
        emailErrMsg: `L'email est incorrect.`,
        verifCode: 'Code de vérification',
        verifCodePlaceholder: `Entrez votre code de vérification`,
        verifCodeErrMsg: `code de vérification incorrect.`,
        btnSendCode: `Envoyez le code de vérification`,
        countdownMsg: `Renvoyer dans {countdown} secondes`,
        orderId: 'ID de commande',
        orderIdPlaceholder: `Entrez votre ID de commande`,
        orderIdErrMsg: `L'ID de la commande est incorrect.`,
        orderAppliedError: `Cette commande a déjà demandé un cadeau.`,
        skuAppliedError: `Le cadeau de cette commande a été récupéré.`,
        orderIdHelp: 'Comment trouver votre identifiant de commande?',
        btnAactivate: 'Activer maintenant',
        statement: `Nous ne partagerons certainement pas vos informations personnelles avec d'autres.`,
        orderIdErrPopoverMsg: `Si votre ID de commande est correct, veuillez contacter notre service client par e-mail. Nous vous aiderons à activer l'extension de garantie et à confirmer si l'événement couvre votre marché.`,
        priceErrPopoverMsg: `Nous sommes désolés de vous dire que cette commande a utilisé notre remise la plus basse, le cas échéant, n'hésitez pas à nous envoyer un e-mail.`
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `Le nom du destinataire ne peut pas correspondre à la commande`,
            `Si l'examen d'Amazon est terminé?`,
            `Voulez-vous continuer à consulter Amazon?`
        ],
        btnRewrite: 'Récrire',
        btnNo: 'NON',
        btnYes: 'OUI'
    },
    // 选择礼物
    chooseGift: {
        title: 'Maintenant, choisissez le cadeau que vous voulez.',
        modalTitle: `Désolé, le cadeau que vous avez sélectionné n'est plus disponible, veuillez choisir à nouveau`,
        btnWant: 'Je le veux',
        btnStockout: 'En rupture de stock'
    },
    // 订单信息
    orderInfo: {
        title: 'Congratulation! Your Extended Warranty is Activated!',
        desp: 'Ce que vous obtiendrez',
        orderTitle: 'Vos informations de commande',
        orderId: 'numéro de commande',
        productASIN: 'Produit ASIN',
        productName: 'Titre du produit',
        address: 'Adresse',
        aboutGift: [
            'À propos du cadeau',
            `AUCUN frais d'expédition, AUCUN frais caché, AUCUNE carte de crédit requise`,
            `4 étapes simples pour l'obtenir (moins de 5 minutes).`,
            'Le cadeau vous sera envoyé dans les 2 à 5 jours ouvrables suivant votre réclamation.'
        ],
        btnWant: 'Je le veux'
    },
    // 步骤1
    stepOne: {
        title: 'Étape 1 sur 4: Un bref sondage sur votre achat.',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. Je suis…?',
                option: [{
                        txt: 'Femelle',
                        value: 0
                    },
                    {
                        txt: 'Masculin',
                        value: 1
                    },
                    {
                        txt: 'Pas certain',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. Quelle est votre tranche d'âge?`,
                option: [{
                        txt: 'Moins de 20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: 'Plus de 60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. Pourquoi nous avez-vous choisis?',
                option: [{
                        txt: 'Marque',
                        value: 0
                    },
                    {
                        txt: 'Conception',
                        value: 1
                    },
                    {
                        txt: 'Prix',
                        value: 2
                    },
                    {
                        txt: 'Caractéristiques',
                        value: 3
                    },
                    {
                        txt: 'Commentaires',
                        value: 4
                    },
                    {
                        txt: 'Autres raisons',
                        value: 5,
                        placeholder: 'Veuillez saisir une raison'
                    }
                ]
            },
        ],
        btnNext: `L'étape suivante`
    },
    // 步骤2
    stepTwo: {
        title: `Étape 2 sur 4: Racontez-nous votre expérience sur le produit.`,
        despOne: `Évaluation globale?`,
        despTwo: `Faites-nous savoir comment nos produits fonctionnent pour vous.`,
        notice: `(Veuillez saisir au moins 10 caractères)`,
        commentPlaceholder: 'Entrez votre commentaire',
        commentErrMsg: `Les mots de commentaire ne peuvent pas dépasser 20 000`,
        btnNext: `L'étape suivante`,
        btnPrev: 'ÉTAPE PRÉCÉDENTE'
    },
    // 步骤3
    stepThree: {
        title: `Étapes 3 sur 4: Partagez votre expérience d'achat avec d'autres.`,
        desp: `JUSTE vous prend quelques secondes. Vos commentaires aideraient d'autres clients à prendre une meilleure décision d'achat. Merci pour votre compréhension et votre soutien.`,
        commentTitle: 'Vos commentaires',
        defaultComment: `J'aime beaucoup votre produit!`,
        btnCopyPost: 'Cliquez ici pour copier et publier votre recension amazom'
    },
    // 步骤4
    stepFour: {
        title: 'Étape 4 sur 4: confirmez votre adresse.',
        desp: 'Ce que vous obtiendrez',
        fullName: 'Nom complet',
        fullNamePlaceholder: `Entrez votre nom complet`,
        fullNameErrMsg: `Le nom complet est incorrect`,
        phone: 'Téléphone',
        phonePlaceholder: `Entrez votre téléphone`,
        phoneErrMsg: `Le téléphone est incorrect`,
        email: 'Courriel',
        emailPlaceholder: `Entrez votre courriel`,
        emailErrMsg: `L'email est incorrect`,
        address: 'Adresse',
        addressPlaceholder: `Entrez votre adresse`,
        addressErrMsg: `L'adresse est incorrecte`,
        streetPlaceholder:`Adresse de rue`,
        apartmentPlaceholder:`Appartement / Unité`,
        cityPlaceholder:`Ville`,
        regionPlaceholder: `Choisissez une région`,
        countryPlaceholder: `Choisissez un pays`,
        postcode: 'Code postal',
        postcodePlaceholder: `Entrez votre code postal`,
        postcodeErrMsg: `Le code postal est incorrect`,
        btnComfirm: 'Confirmez'
    },
    // 完成礼物申请
    completeApplication: {
        title: `Vous avez terminé l'application cadeau gratuite`,
        msgs: [
            'Le cadeau gratuit sera expédié sous 2 à 5 jours ouvrables.',
            'Le cadeau gratuit sera envoyé à votre email ',
            ` dans 2-5 jours ouvrables.Merci sincèrement d'avoir acheté nos produits, il y aura ensuite un contact dédié à l'équipe après-vente.`,
            'Pour tout autre problème que vous pourriez rencontrer, veuillez contacter notre service client par e-mail ou visitez notre site officiel.',
            `Puisque vous n'êtes pas 100% satisfait de nos produits, vous pouvez contacter notre service client par email ou visiter notre site officiel, il y aura des professionnels pour vous servir. La satisfaction du client à 100% est notre garantie!`
        ],
        btnComfirm: 'Confirmez'
    },
    // 获取订单号指导
    guide: {
        title: 'Comment trouver votre ID de commande?',
        desps: [
            `Étape 1: Connectez-vous à votre compte Amazon et cliquez sur «Votre commande» dans la page Compte et listes`,
            `Étape 2: Cliquez sur «Détails de la commande» dans la bonne commande`,
            `Étape 3: Vous verrez votre ID de commande`
        ],
        btnOK: `D'accord`
    }
}

export default fr